import React, { useState } from "react";
import { useGlobalState } from '../Context/GlobalContext';
import { Box } from "@mui/material";
import OrderEntryCore from "../Component/OrderEntry/OrderEntryCore";
import { useNavigate } from "react-router-dom";
import { PROTOCOL_TYPES } from "../Constants/AppConstants";
import { isLiveOrder } from "../Constants/stagingBlotter";
import { isTradingDeskSelected } from "../Component/OrderEntry/optionsHelper";

const OrderEntryPage = ({
  readOnly = false,
  onClose,
  source = "navbar",
  initialActiveTab = 0,
  tabName = "empty",
  onOrderAdded,
  initialData,
  qtyPriceEditMode = false, // added to match OrderEntry props
}) => {
  const { cusip, side, quantity } = useGlobalState();
  const navigate = useNavigate();

  // Clear-all callback to allow OrderEntryCore to register a clear function (same pattern as OrderEntry modal)
  const [clearAllCallback, setClearAllCallback] = useState(null);

  const handleClose = () => {
    if (clearAllCallback) {
      clearAllCallback();
    }
    if (onClose) onClose();
  };

  const handleSubmitSuccess = (success, activeTab, orderData) => {
    let expandOrderId = undefined;
    if (activeTab === 0 && orderData.protocol === PROTOCOL_TYPES.RFQ) {
      expandOrderId = success;
    }

    // Trading Desk is not a market destination -- the order stays in the Staging Blotter --
    // so always land the trader on it (view 0, tab 0). This has to sit ahead of the
    // source-specific branches below, which redirect to the Order Blotter unconditionally,
    // and ahead of the isLiveOrder() check, which reads the staging flag: a draft raised
    // from Order Entry never carries that flag (only the send-to-market flow stamps it),
    // so Number(undefined) !== 0 made every Trading Desk order look live.
    if (activeTab === 0 && isTradingDeskSelected(orderData.venue)) {
      navigate(`/order?view=0&tab=0${expandOrderId ? `&expandOrderId=${expandOrderId}` : ""}`, {
        replace: true,
      });
      return;
    }

    if (source === "sendToMarket") {
      navigate(`/order?view=1&tab=0${expandOrderId ? `&expandOrderId=${expandOrderId}` : ""}`);
      return;
    }

    let redirectView = 0;
    let redirectTab = activeTab;

    if (activeTab === 0) {
      const venue = orderData.venue;
      if (venue && isLiveOrder(orderData)) {
        redirectView = 1;
      }
    }

    navigate(`/order?view=${redirectView}&tab=${redirectTab}${expandOrderId ? `&expandOrderId=${expandOrderId}` : ""}`, {
      replace: true,
    });
  };

  return (
    <Box sx={{ 
      width: "100%",
      height: "89vh",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    }}>
      <OrderEntryCore
        readOnly={readOnly}
        onClose={handleClose} // use the new close handler to clear state first
        source={source}
        initialActiveTab={initialActiveTab}
        tabName={tabName}
        cusip={cusip}
        side={side}
        qty={quantity}
        onOrderAdded={onOrderAdded}
        initialData={initialData}
        showTabs={true}
        showFooter={true}
        onSubmitSuccess={handleSubmitSuccess}
        containerStyle={{ 
          flex: 1,
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
        }}
        onClearAll={setClearAllCallback} // allow core to register a clear callback
        qtyPriceEditMode={qtyPriceEditMode} // pass through edit mode flag
      />
    </Box>
  );
};

export default OrderEntryPage;